const SelectorTypeEnum = Object.freeze({
    Checkbox: 1,
    RadioButton: 2,
});

export { SelectorTypeEnum };